st.ProductExpirationCountdown = class ProductExpirationCountdown {
  constructor($element) {
    this.$element = $element
    if (this.$element.data("expireAt")) { this.expireAt = moment(this.$element.data("expireAt")) }

    this._interval = setInterval((() => this.render()), 250)
  }

  getTimeDiff() {
    return this.expireAt ? this.expireAt.unix() - moment().unix() : null
  }

  getCountdownText() {
    const timeDiff = this.getTimeDiff()
    if (!timeDiff) { 
      return null 
    }
    if (timeDiff <= 0) {
      return I18n.t("fe.pricelist_expiration_countdown.product_finished")
    }

    const d = Math.floor(timeDiff / 86400)
    const h = Math.floor((timeDiff % 86400) / 3600)
    const m = Math.floor((timeDiff % 3600) / 60)
    const s = timeDiff % 60

    const strings = []
    if (d > 0) { strings.push(`${d}d`) }
    if (h > 0) { strings.push(`${h}h`) }
    if (m > 0) { strings.push(`${m}m`) }
    if (s > 0 && !d) { strings.push(`${s}s`) }

    if (d > 7) {
      return I18n.t("fe.pricelist_expiration_countdown.product_about_to_finish")
    } else if (d >= 1) {
      return I18n.t("fe.pricelist_expiration_countdown.x_left_to_end_of_discount", {time: I18n.t("base.x_days", {count: d})})
    } else {
      return I18n.t("fe.pricelist_expiration_countdown.x_left_to_end_of_discount", {time: strings.join(" ")})
    }
  }

  render() {
    const timeDiff = this.getTimeDiff()

    this.$element.html(this.getCountdownText())

    if (timeDiff >= 86400) {
      this.$element[0].className = "alert alert-success"
    } else if (timeDiff > 0) {
      this.$element[0].className = "alert alert-warning"
    } else {
      this.$element[0].className = "alert alert-danger"
    }

    if (timeDiff < 0) {
      $(".st-product-expiration-countdown-cta button").prop("disabled", true)
      this.destroy()
    }
  }

  destroy() {
    if (this._interval) {
      clearInterval(this._interval)
      delete this._interval
    }
  }
}

$(document).ready(() =>
  $(".st-product-expiration-countdown").each(function() {
    return window.ProductExpirationCountdown = new st.ProductExpirationCountdown($(this))
  })
)



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/product_expiration_countdown.js